import React from "react";
import AgendaItemRowContainer from "./AgendaItemRow.styles";
import Tooltip from "@mui/material/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faUser,
    faBriefcase,
    faClipboard,
} from "@fortawesome/free-solid-svg-icons";
import { AgendaItem } from "../../../../screens/Company/MorningMeetingDetails/MorningMeetingDetails.types";
import FileDisplay from "../../../Common/FileDisplay/FileDisplay";
import * as Database from "../../../../utils/database.utils";
import { useSettings } from "../../../../context/Settings.context";
import { useHistory } from "react-router-dom";

interface Props {
    data: AgendaItem;
    index: number;
}

const AgendaItemRow = ({ data, index }: Props) => {
    const history = useHistory();
    const { setShowLoadingToast, setToast } = useSettings();

    const downloadFile = async (
        meetingId: string,
        agendaItemId: string,
        fileId: string
    ) => {
        setShowLoadingToast({ show: true, message: "DOWNLOADING" });
        try {
            const response = await Database.get(
                `api/bqmq_voting/morning-meetings/${meetingId}/agenda-items/${agendaItemId}/files/${fileId}`
            );
            const data = await response.json();
            const uri: string = data.data.uri;
            const link = document.createElement("a");
            link.href = uri;
            link.download = fileId;
            link.click();
        } catch (error) {
            console.error("Download failed:", error);
            setToast({
                show: true,
                message: "There was an error downloading the file.",
                type: "error",
            });
        } finally {
            setShowLoadingToast({ show: false, message: "" });
        }
    };

    const openEditAgendaItemPage = () => {
        history.push(
            `/portfolio/morning-meetings/${data.morning_meeting_id}/agenda-item?id=${data.id}`
        );
    };

    return (
        <AgendaItemRowContainer onClick={openEditAgendaItemPage}>
            <div className="order">{index + 1}</div>
            <div className="agenda-item">
                <div className="info">
                    <div className="name">{data.topic}</div>
                    <div className={"details"}>
                        <Tooltip title={<h2>SPEAKER</h2>}>
                            <div className={"detail"}>
                                <FontAwesomeIcon icon={faUser} fixedWidth />
                                <p className={"capitalize"}>
                                    {data.speaker_name}
                                </p>
                            </div>
                        </Tooltip>
                        <Tooltip title={<h2>TOPIC CLASSIFIER</h2>}>
                            <div className={"detail"}>
                                <FontAwesomeIcon
                                    icon={faClipboard}
                                    fixedWidth
                                />
                                <p className={"capitalize"}>
                                    {data.topic_classifier.value}
                                </p>
                            </div>
                        </Tooltip>
                        {data.company && (
                            <>
                                <Tooltip title={<h2>COMPANY</h2>}>
                                    <div className={"detail"}>
                                        <FontAwesomeIcon
                                            icon={faBriefcase}
                                            fixedWidth
                                        />
                                        <p className={"capitalize"}>
                                            {data.company.name}
                                        </p>
                                    </div>
                                </Tooltip>
                                <div className={"detail"}>
                                    <p className={"capitalize"}>
                                        BQ: {data.company.bq}
                                    </p>
                                </div>
                                <div className={"detail"}>
                                    <p className={"capitalize"}>
                                        MQ: {data.company.mq}
                                    </p>
                                </div>
                                <div className={"detail"}>
                                    <p className={"capitalize"}>
                                        Portfolio weight:{" "}
                                        {data.company.portfolio_weight || ""}
                                    </p>
                                </div>
                                <div className={"detail"}>
                                    <p className={"capitalize"}>
                                        FV:{" "}
                                        {data.company.fair_value_upside_pct ||
                                            ""}
                                    </p>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                {data.files.length > 0 && (
                    <div className="files">
                        {data.files.map(({ name, id }) => (
                            <div className="file-wrapper" key={id}>
                                <FileDisplay
                                    value={name}
                                    onClick={(event: any) => {
                                        event.stopPropagation();
                                        downloadFile(
                                            data.morning_meeting_id,
                                            data.id,
                                            id
                                        );
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </AgendaItemRowContainer>
    );
};
export default AgendaItemRow;
